import axios, { AxiosResponse } from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
const BASE_URL = NAMESPACES.configuration_api.unidades_medida;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({ baseURL: BASE_URL, headers: { 'Content-Type': 'application/json' } }));

// Thin cached axios wrapper using the registry under the hood
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'configuration_api',
  group: 'unidades_medida',
  // default TTL can be set as human string as well
  defaultTtl: '30m',
  hashLargeSegments: true,
  emitMeta: true,
});

// Function to fetch all items
export const getAllUnidadesMedida = async (): Promise<AxiosResponse<any>> => {
  return await cachedApi.get<any>('/GetAllUnidadesMedida', undefined, { ttl: '2h' });
};

/**
 * /GetAllUnitConversions
 */

export const getAllUnitConversions = async (): Promise<AxiosResponse<any>> => {
  return await cachedApi.get<any>('/GetAllUnitConversions', undefined, { ttl: '2h' });
};

// Optional: expose a simple clear helper for this scope
export const clearUnidadesMedidaCache = async (): Promise<void> => {
  await cachedApi.clear();
};
